import React from 'react'
import Image from '../../Image'
import { East, PlayCircleFilledRounded } from '@mui/icons-material'
import { Button } from '@mui/material'
import Text from '../../Text'
import classNames from 'classnames'

const Face1 = ({ Title,mainImageClass,isDemo, description,mainContainerClass, btnClass, mainImage }: {
  Title?: string | JSX.Element | JSX.Element[],
  description?: string | JSX.Element | JSX.Element[],
  btnClass?: string,
  isDemo?:boolean,
  mainContainerClass?: string,
  mainImage?: string,
  mainImageClass?: string
}) => {
  return (
    <div className={`${mainContainerClass || ""} flex Face1background pt-[167.58px] gap-x-[21.79px] pl-[118px] pr-[85px]`} >
      <div className='w-1/2'>
        {Title}
        <div className='mt-[27px] mb-[35px] opacity-[69%]'>
          <Text className='text-[21px] opacity-60 font-light'>
            {description}
          </Text>
        </div>
        <div className='flex gap-[15px] items-center'>
          <Button variant='contained' className={classNames(btnClass,'!bg-[#239405] !gap-3 !w-[249.1px] !capitalize !font-light !text-[18px] !h-[73.77px] !rounded-[11px] !shadow-[0px_10px_0px_0px_rgba(18,87,0,1)]')}>
            Get Started
            <East />
          </Button>
          {isDemo && <div className='flex gap-[13px] items-center'>
            <PlayCircleFilledRounded className='!fill-[#DC9F31] !text-[60px]' />
            <Text className='text-[#000000] underline  opacity-[64%] text-[24px]'>Watch Demo</Text>
          </div>}
        </div>
        </div>
      <div className={classNames( mainImageClass, 'w-1/2')}>
        <Image
          className=''
          src={mainImage}
        />
      </div>
    </div>
  )
}

export default Face1